// src/pages/Login/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import './Login.css';

const Login = () => {
    const navigate = useNavigate();

    // Basic form fields
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    // Actual backend call to /auth/login
    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const response = await api.post('/auth/login', { username, password });
            const { token, user } = response.data;

            // Save both token and tenantId for subsequent requests
            localStorage.setItem('token', token);
            localStorage.setItem('tenantId', user.tenantId);

            // Also store user role if needed for UI decisions
            localStorage.setItem('userRole', user.role);

            navigate('/dashboard');
        } catch (err) {
            // Show the server's error or a generic one
            setError(err.response?.data?.error || 'Login failed');
        }
    };

    // Placeholder for social login
    const handleSocialLogin = (provider) => {
        alert(`Login with ${provider} not yet implemented!`);
    };

    return (
        <div className="login-page-container">
            <div className="login-box">
                {/* Logo & Tagline */}
                <div className="login-logo-row">
                    <img src="/SLAILOGO.png" alt="SLAI Logo" className="slai-logo" />
                    <h2 className="slai-text">straightline.ai</h2>
                </div>
                <p className="demo-text">
                    Don't have an account? <a href="#contact-us">Contact us for a Free Demo</a>
                </p>

                <div className="login-form-wrapper">
                    {/* Left side: user/pass form */}
                    <form onSubmit={handleLogin} className="login-form">
                        <label>Username</label>
                        <input
                            type="text"
                            placeholder="Enter your Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />

                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="Enter your Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />

                        {error && <p className="login-error">{error}</p>}

                        <div className="forgot-row">
                            <Link to="/forgot-password">Forgot My Password</Link>
                        </div>

                        <button type="submit" className="login-btn">Log in</button>
                    </form>

                    {/* Right side: Social logins */}
                    {/*<div className="social-logins">
                        <button
                            className="social-btn google"
                            onClick={() => handleSocialLogin('Google')}
                        >
                            <img src="/icons/google.png" alt="Google Icon" />
                            Login with Google
                        </button>
                        <button
                            className="social-btn microsoft"
                            onClick={() => handleSocialLogin('Microsoft')}
                        >
                            <img src="/icons/microsoft.png" alt="Microsoft Icon" />
                            Login with Microsoft
                        </button>
                        <button
                            className="social-btn apple"
                            onClick={() => handleSocialLogin('Apple')}
                        >
                            <img src="/icons/apple.png" alt="Apple Icon" />
                            Login with Apple
                        </button>
                    </div>*/}
                </div>

                {/* Footer */}
                <div className="login-footer">
                    <p>©2025 SLAI, Inc. All Rights Reserved.</p>
                    <p>
                        <a href="#privacy">Privacy Policy</a>,{' '}
                        <a href="#cookies">Manage Cookies</a>,{' '}
                        <a href="#choices">Your Privacy Choices</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;